import { render, staticRenderFns } from "./ObiButtonSwitch.vue?vue&type=template&id=25ea9957&scoped=true&"
import script from "./ObiButtonSwitch.vue?vue&type=script&lang=js&"
export * from "./ObiButtonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ObiButtonSwitch.vue?vue&type=style&index=0&id=25ea9957&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea9957",
  null
  
)

export default component.exports